import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useCurrentShopAdmin } from "@/api/shops/use-shop-admin";
import { useViewerIsSuperAdmin } from "@/lib/rights/use-viewer-is-baback-team";
import { useOpenReturnWidget } from "@/pages/(app)/embed/use-open-return-widget";
import useTranslation from "@babackapp/translations/use-translation";
import { Badge } from "@babackapp/ui/components/badge";
import { SidebarMenuButton, useSidebar } from "@babackapp/ui/components/sidebar";
import { SparklesIcon } from "lucide-react";

/**
 * Opens the V3 return portal (apps/return-widget-embed) as an overlay inside the
 * dashboard. Always available to the Baback team; merchants only see it once a
 * super admin turns on the shop's `admin.returnWidget.demo` flag.
 */
export default function DemoReturnWidgetButton() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const { data: admin } = useCurrentShopAdmin();
  const isSuperAdmin = useViewerIsSuperAdmin();
  const { state } = useSidebar();
  const openReturnWidget = useOpenReturnWidget(shop.shopifyUrl, shop.providerId, {
    forceNewWidget: true,
    lang: shop.preferences.languages[0],
  });

  if (!isSuperAdmin && !admin?.returnWidget?.demo) return null;

  const className = "text-sidebar-foreground/70 hover:text-sidebar-foreground";

  if (state === "collapsed") {
    return (
      <SidebarMenuButton
        size="sm"
        onClick={openReturnWidget}
        tooltip={t("sidebar.demoNewPortal")}
        className={className}
      >
        <SparklesIcon className="text-indigo-500" />
      </SidebarMenuButton>
    );
  }

  return (
    <SidebarMenuButton size="sm" onClick={openReturnWidget} className={className}>
      <SparklesIcon className="text-indigo-500" />
      <span>{t("sidebar.demoNewPortal")}</span>
      {/* Same treatment as the nav items' badge, see section.tsx */}
      <Badge
        variant="default"
        size="xs"
        className="ml-auto rounded-full border-0 bg-gradient-to-r from-indigo-500 to-purple-500 px-1.5 text-[10px] font-semibold uppercase tracking-wide text-white shadow-sm"
      >
        {t("sidebar.badgeNew")}
      </Badge>
    </SidebarMenuButton>
  );
}
